<section class="table-container" 
[ngStyle]="{ height:
      tableViewFullSizeEnabled
      ? '90vh'
      : '100%'
  }"
>
  <div class="first-heading">
    <ng-content></ng-content>
  </div>
  <div [hidden]="!showTable" class="ag-grid-table-container">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      theme="legacy"
      [modules]="modules"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [selectionOptions.isRowSelectable]="isRowSelectable"
      [components]="frameworkComponents"
      [tooltipShowDelay]="tooltipShowDelay"
      [groupDisplayType]="groupDisplayType"
      [rowGroupPanelShow]="rowGroupPanelShow"
      [rowSelection.enableClickSelection]="!suppressRowClickSelection"
      [cellSelection]="enableRangeSelection"
      [groupRowRendererParams]="groupRowRendererParams"
      [pagination]="paginationRequired"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [paginationPageSize]="paginationPageSize"
      [masterDetail]="masterDetail"
      [detailCellRendererParams]="detailCellRendererParams"
      (cellClicked)="onCellClicked($event)"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
      (columnResized)="onColumnResized($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (cellEditingStarted)="editCell($event)"
      (cellEditingStopped)="onCellEditingStopped($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      (paginationChanged)="onPaginationChanged($event)"
      (rowGroupOpened)="onRowGroupOpened($event)"
      (filterChanged)="filterChanged($event)"
      (sortChanged)="sortChanged($event)"
      [rowClassRules]="rowClassRules"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
    >
    </ag-grid-angular>
  </div>
</section>
